import { map } from 'rxjs/operators/map';
import { WorkflowSerializer } from '../../models';
import ajax from '../../utils/ajax';

class WorkflowService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/workflow';
  configurationPathGroup = '/networkAsset/airfinder/workflows';

  /**
    Get workflows by site id
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized workflows
  */
  getBySiteId = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(WorkflowSerializer.normalize)));
  };

  /**
    Get a workflow by id
    @param {String} workflowId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  get = (workflowId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${workflowId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => WorkflowSerializer.normalize(data.response)));
  };

  /**
    Create a workflow
    @param {Object} workflow
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (workflow, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: WorkflowSerializer.serialize(workflow),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => WorkflowSerializer.normalize(data.response)));
  };

  /**
    Edit a workflow
    @param {Object} workflow
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (workflow, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${workflow.id}`,
        body: WorkflowSerializer.serializeEdit(workflow),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => WorkflowSerializer.normalize(data.response)));
  };

  /**
    Delete a workflow
    @param {Object} workflow
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  delete = (workflow, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${workflow.id}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new WorkflowService();



// WEBPACK FOOTER //
// ./src/services/workflow/index.js